import { useService } from 'react-reservice';

import { EColumnPreferenceOrderType } from '@aqx-core/common/api/user-account-setting';

import { accountColumnSettingService } from './service';

export const useAccountColumnSettings = () => useService(accountColumnSettingService, (context) => context);

export const useColumnSettingData = () => {
  return useService(accountColumnSettingService, (context) => ({
    defaultColumnSettings: context.defaultColumnSettings,
    fixedColumnSettings: context.fixedColumnSettings,
    editingColumnSettings: context.editingColumnSettings,
    isResetDefaultButtonDisabled: context.isResetDefaultButtonDisabled,
    currentColumnSettingType: context.currentColumnSettingType,
    isDirty: context.isDirty
  }));
};

export const useColumnPreferenceByOrderType = (type: EColumnPreferenceOrderType) => {
  const data = useService(
    accountColumnSettingService,
    (context) => context.data[type]?.currentSettings ?? context.data[type]?.defaultSettings
  );
  return data ?? [];
};

export const useColumnPreferences = () => {
  return useService(accountColumnSettingService, (context) => context.data);
};
